import React from 'react';

interface Props {
  url?: string | null;
  name?: string;
  /** Tailwind size classes, e.g. "w-10 h-10". */
  size?: string;
  /** Background + text classes used for the initial fallback. */
  bg?: string;
  text?: string;
  className?: string;
}

// One place that renders a user's profile picture, falling back to their
// initial. Used everywhere an avatar appears so pictures show consistently.
const Avatar: React.FC<Props> = ({
  url,
  name,
  size = 'w-10 h-10',
  bg = 'bg-emerald-600',
  text = 'text-white font-semibold',
  className = '',
}) => (
  <div className={`${size} ${bg} rounded-full overflow-hidden flex items-center justify-center shrink-0 ${text} ${className}`}>
    {url ? (
      <img src={url} alt={name || ''} className="w-full h-full object-cover" />
    ) : (
      <span>{(name || '?').charAt(0).toUpperCase()}</span>
    )}
  </div>
);

export default Avatar;
